import Joi from 'joi';
import { rutValidation } from '../../../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  clientName: Joi.string().error(new Error('Nombre requerido')),
  phone: Joi.number()
    .min(10 ** 8)
    .max(10 ** 9 - 1)
    .error(new Error('Ingresar 9 dígitos')),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .error(new Error('Ingresar un correo válido')),
  comment: Joi.string().max(250).error(new Error('Descripción es requerida')),
});
